import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import { CDFILeadsQuota } from '../models/CDFI-leads-quota';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { SourceTypes } from '../../../../shared/models/source-types';
import { CreateLeadQuota } from '../models/create-lead-quota';

@Injectable({
  providedIn: 'root',
})
export class CdfiLeadsQuotaService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getLeadsQuota(
    pageNo = 1,
    pageSize = 10,
    search?: string,
  ): Observable<PaginatedResponse<CDFILeadsQuota>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<PaginatedResponse<CDFILeadsQuota>>(
      this.adminApiBaseUrl + '/lead-quota',
      { params },
    );
  }

  updateMaxLeadsQuota(
    connectionId: number,
    maxLeadsQuota: number,
    sourceType: number,
  ): Observable<CDFILeadsQuota> {
    return this.http.patch<CDFILeadsQuota>(
      this.adminApiBaseUrl + '/lead-quota/' + connectionId,
      { source_type: sourceType, max_quota: maxLeadsQuota },
    );
  }

  deleteLeadsQuota(
    source_types: number[],
    connectionId: number,
  ): Observable<CDFILeadsQuota> {
    return this.http.delete<CDFILeadsQuota>(
      this.adminApiBaseUrl + '/lead-quota/' + connectionId,
      { body: { source_types: source_types } },
    );
  }

  getAllSourceTypes(): Observable<SourceTypes[]> {
    return this.http.get<SourceTypes[]>(this.adminApiBaseUrl + '/source-types');
  }

  createLeadsQuota(
    connectionId: number,
    createLeadQuotaModel: CreateLeadQuota[],
  ): Observable<unknown> {
    return this.http.post<unknown>(
      this.adminApiBaseUrl + '/lead-quota/' + connectionId,
      createLeadQuotaModel,
    );
  }
}
